// extracted by mini-css-extract-plugin
export var cardHeader = "_fs-0";
export var reorderHandle = "_fs-3";
export var titleArea = "_fs-1";
export var titleAreaWithHandle = "_fs-2";